<template>
  <footer>
    <!-- <p>北京艾西智酷科技有限公司 | Copyright ©2020 icpeixun.com | <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备190326638号-6</a></p>
    <p>地址 : 北京市朝阳区来广营西路5号院5号楼15层1508 | 联系邮箱：yaojian@iczhiku.com | 电话：010-53322081（工作日9:00-18:00）</p>注释掉网站页脚20220408byfgq -->
  </footer>
</template>

<script>
export default {
  name: "footers"
};
</script>
<style scoped>
footer {
  background-color: rgb(255, 255, 255);
  width: 100%;
  min-width: 1200px;
  height: 114px;
  font-size: 14px;
  color: #333;
  line-height: 30px;
  padding-top: 40px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/footer.vue